import { Component, Input, OnInit } from '@angular/core';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'widget-legend',
  templateUrl: './widget-legend.component.html',
  styleUrls: ['./widget-legend.component.css']
})
/** widget-legend component*/
export class WidgetLegendComponent implements OnInit {
  @Input() legendData: any[] = [];
  @Input() callingRoutine: string;

  constructor(private _logger: LogService) { }

  ngOnInit(): void {
    this._logger.trackEvent('Dashboard', "rollover", 'MarketWidget');
  }
}
